import { createSelector } from 'reselect';
import get from 'lodash/get';

import { SCOPE } from './types';

const selector = state => get(state, SCOPE);
/* const configCreateQuery = {
  configuration: {
  },
}; */

export const dataSelector = createSelector(selector,
  configState => (configState.response ? configState.response : {}));

export const errorConfigSelector = createSelector(selector,
  configState => configState.newConfigPanel);

  export const configCreatePayloadSeletor = createSelector(selector,
    errorConfigSelector,
    (configState, errorConfig) => {
      const config = { configuration: {} };
      Object.assign(config.configuration, errorConfig);
      delete config.configuration['id'];
      // const payload = JSON.parse(JSON.stringify(configCreateQuery));
      return config;
    },
);

export const configContainerVisibilitySelector = createSelector(selector,
  configState => configState.visible);

export const errorConfigNameSelector = createSelector(errorConfigSelector,
  configState => configState.name);

export const errorConfigRuleSelector = createSelector(errorConfigSelector,
  configState => configState.rule);

export default selector;